module.exports = __webpack_public_path__ + "static/media/right-arrow-black.a17e052f.svg";